import React from 'react';
import { EDataType } from 'src/modules/network-configuration/models/node-data';

import { INodeEditData } from './type';

interface IProps {
  values: INodeEditData;
  type: EDataType;
  setValues: (value: React.SetStateAction<INodeEditData>) => void;
  errors: {
    name: string;
  };
}

export default function EditPorts({ values, setValues, type, errors }: IProps) {
  return (
    <div className="mt-2 flex flex-col items-center justify-start gap-2">
      EditPorts
    </div>
  );
}
